import React from "react";
import {
  EXPORT_OPTION,
  EXPORT_OPTION_LABEL_MAP
} from "utils/constants/insights";
import { CSVLink } from "react-csv";
import { prepareCSVExportData } from "utils/exportData";
import HoverIconButton from "components/HoverIconButton";

const EXPORT_MAP = {
  [EXPORT_OPTION.CSV]: prepareCSVExportData
};

const ExportDataControls = ({
  types = [],
  rows = [],
  keys,
  rename,
  format,
  filename,
  tooltip,
  labels
}) => {
  return (
    <div className="flex flex-row">
      {types.reduce((memo, type, typeIx) => {
        const exportFn = EXPORT_MAP[type];
        if (exportFn) {
          const iconProps = {
            type,
            tooltip: tooltip || `Export ${EXPORT_OPTION_LABEL_MAP[type]}`,
            disabled
          };
          const { data, headers } = exportFn({
            labels,
            rows,
            format,
            rename,
            keys
          });

          const disabled = data.length === 0;

          if (disabled) {
            memo.push(<HoverIconButton key={typeIx} {...iconProps} />);
          } else {
            memo.push(
              <CSVLink
                data={data}
                headers={headers}
                key={typeIx}
                filename={filename}
              >
                <HoverIconButton {...iconProps} />
              </CSVLink>
            );
          }
        }
        return memo;
      }, [])}
    </div>
  );
};

export default ExportDataControls;
